<template>
  <div class="md-layout" >
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }}</h1>
      </div>
    </div>

    <ElasticList :list="list"></ElasticList>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  import Page from '@/mixins/Page';

  export default {
    components: {
      ElasticList
    },
    mixins: [Page],
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "teams",
          pageTitle: "Teams",
          pageIcon: "folder",
          listQueryId: "searchTeams",
          deleteQueryId: "deleteTeam",
          linkRows: true,
          deleteGroupId: "cognito_groupid",
          columns: {
            name: { label: "Name", sortable: true },
            // cognito_groupid: { label: "Group Name", sortable: true},
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          // formatResponse: (data) => {
          //   let result = [];
          //     if (data && data.searchTeams && data.searchTeams.items.length) {
               
          //       data.searchTeams.items.forEach((item) => {
          //         if(item.cognito_groupid != null) {
          //           item.cognito_groupid = item.cognito_groupid.replace(/_/g, " ");
          //         }
          //         result.push(item);
          //       })
          //     }
          //   return result;
          // }
        },
      };
    },
  };
</script>

<style></style>
